module.exports = __webpack_public_path__ + "assets/boomerang.ab2db6fd.svg";